module.exports = __webpack_public_path__ + "c2170a7b790a00dc1fae79ce854325a4.svg";